<script>
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { checkbox, Radio },
    props: {
      solicitacao: Object,
      edicao: Boolean
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
    },
    methods: {
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
    },
    mounted() {
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="descricao-doacao">
            Informações doação
          </label>

          <textarea class="form-control"
                    id="descricao-doacao"
                    style="height: 500px;"
                    v-model="solicitacao.solicitacaoDoacao[0].descricaoDoacao">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosAdicionaisDoacoes.vue